import { GetSongs as DLGetSongs, SaveSong as DLSaveSong, DeleteSong as DLDeleteSong, SendKaraokeCamConfig as DLSendKaraokeCamConfig } from './../../../DL/Admin/Games/Karaoke'


/**
 * ==============================================================================
 * BUSINESS LOGIC (BL): Lógica de negocio y puente entre Vista y Datos
 * ==============================================================================
 */

// Obtener todas las canciones
const GetSongs = async () => {
  try {
    const response = await DLGetSongs()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error inesperado en BL al obtener canciones.' }
  }
}

// Guardar canción (formatea el payload si es necesario)
const SaveSong = async (song) => {
  try {
    // Validaciones de negocio podrían ir aquí antes de llamar al DL
    if (!song.name || !song.lyrics) {
      return { success: false, message: 'La canción debe tener nombre y letra.' }
    }

    // Preparamos el objeto tal cual lo espera el Back (DTO)
    const payload = {
      Id: song.id,
      Name: song.name,
      Artist: song.artist,
      Url: song.url,
      Lyrics: song.lyrics
    }

    const response = await DLSaveSong(payload)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error inesperado en BL al guardar canción.' }
  }
}

// Eliminar canción
const DeleteSong = async (songId) => {
  try {
    const response = await DLDeleteSong(songId)

    if (response.success) {
      return { success: true }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error inesperado en BL al eliminar canción.' }
  }
}

// const UpdateKaraokeCamOverlay = async (configData) => {
//     try {
//         // Nos aseguramos de mandar enteros
//         const safeData = {
//             showMic: Boolean(configData.showMic),
//             showNotes: Boolean(configData.showNotes),
//             showText: Boolean(configData.showText),
//             micX: Math.round(configData.micX || 0),
//             micY: Math.round(configData.micY || 0),
//             micRotation: Math.round(configData.micRotation || 0),
//             textNotesX: Math.round(configData.textNotesX || 0),
//             textNotesY: Math.round(configData.textNotesY || 0)
//         };
//         return await DLSendKaraokeCamConfig(safeData);
//     } catch (error) {
//         return { success: false, message: 'Error en BL.' };
//     }
// };

const UpdateKaraokeCamOverlay = async (configData) => {
    try {
        const safeData = {
            showMic: Boolean(configData.showMic),
            showNotes: Boolean(configData.showNotes),
            showText: Boolean(configData.showText),
            
            micX: Math.round(configData.micX || 0),
            micY: Math.round(configData.micY || 0),
            micRotation: Math.round(configData.micRotation || 0),
            micScale: parseFloat(configData.micScale) || 1.0,
            
            notesX: Math.round(configData.notesX || 0),
            notesY: Math.round(configData.notesY || 0),
            notesScale: parseFloat(configData.notesScale) || 1.0,
            
            textX: Math.round(configData.textX || 0),
            textY: Math.round(configData.textY || 0),
            textScale: parseFloat(configData.textScale) || 1.0,
            customText: configData.customText || "¡Canta con nosotros!"
        };
        return await DLSendKaraokeCamConfig(safeData);
    } catch (error) {
        return { success: false, message: 'Error en BL.' };
    }
};

export { GetSongs, SaveSong, DeleteSong, UpdateKaraokeCamOverlay };









// const GetSongs  = async () => {
//   try {
//     const response = await DLGetSongs()
    
//     if (response.success) {
//         return { success: true, data: response.data }
//     } else {
//         return { success: false, message: response.message }
//     }
//   } catch (error) {
    
//   }
// }

// export { GetSongs };